import { create } from "zustand";
import { createJSONStorage, persist, StateStorage } from "zustand/middleware";

// Whether the user collapsed the main nav on screens without a secondary
// menu, where it otherwise stays expanded as a persistent column.
type PrimaryRailCollapsedState = {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
};

const noopStorage: StateStorage = {
  getItem: () => null,
  setItem: () => undefined,
  removeItem: () => undefined,
};

const safeLocalStorage: StateStorage = {
  getItem: (name) => {
    try {
      return window.localStorage.getItem(name);
    } catch {
      return null;
    }
  },
  setItem: (name, value) => {
    try {
      window.localStorage.setItem(name, value);
    } catch {
      return;
    }
  },
  removeItem: (name) => {
    try {
      window.localStorage.removeItem(name);
    } catch {
      return;
    }
  },
};

export const usePrimaryRailCollapsedStore = create<PrimaryRailCollapsedState>()(
  persist(
    (set) => ({
      collapsed: false,
      setCollapsed: (collapsed) => set({ collapsed }),
    }),
    {
      name: "admin-primary-rail-collapsed",
      version: 1,
      storage: createJSONStorage(() =>
        typeof window === "undefined" ? noopStorage : safeLocalStorage,
      ),
      partialize: (state) => ({ collapsed: state.collapsed }),
      merge: (persisted, current) => ({
        ...current,
        collapsed:
          (persisted as { collapsed?: unknown } | null)?.collapsed === true,
      }),
    },
  ),
);
